webpackJsonp([229338760157850],{

/***/ 2111:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"MarketingQueries","kind":"OBJECT","type":"QUERY","fields":[{"args":[{"defaultValue":null,"description":"ID of resource to lookup","name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"newsletter","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Newsletter","ofType":null}}},{"args":[{"defaultValue":null,"description":null,"name":"updatedAtEnd","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"updatedAtStart","type":{"kind":"SCALAR","name":"NaiveDateTime","ofType":null}}],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"newsletters","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"LIST","name":null,"ofType":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"Newsletter"}}}}}],"description":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---query-marketing-queries-5b6c560c0b0fa9ef33db.js